import api from '../../api/'
const state = {
    all:[],
    paiement:[],
    models:[],
    codes:[],
    recent_retrait:[],
    linesError:[],
    montantttc:0
}
const getters= {
    rows(state){
        let data = []
        let row = {
            id: "",
            user_nom: "",
            entite_nom: "",
            agence_nom: "",
            guichet_nom: "",
            typeoperation_code: "",
            piece_libelle: "",
            nom: "",
            prenom: "",
            adresse: "",
            telephone: "",
            num_piece: "",
            montant_transfere: "",
            montant_commission: "",
            montant_tva: "",
            montant_ttc: "",
            reliquat: "",
            tarif: "",
            taux_commission: "",
            taux_tva: "",
            code_envoi: "",
            num_transation: "",
            created_at: null,
            date_operation: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => { 
            console.log("Opérations ",element)        
            row = {
                id: element.id,
                user_nom:element.user_nom.toUpperCase(),
                entite_nom: element.entite_nom.toUpperCase(),
                agence_nom: element.agence_nom.toUpperCase(),
                guichet_nom: element.guichet_nom.toUpperCase(),
                typeoperation_code: element.typeoperation_code.toUpperCase(),
                piece_libelle: element.piece_libelle,
                nom: element.nom,
                prenom: element.prenom,
                adresse: element.adresse,
                telephone: element.telephone,
                num_piece: element.num_piece,
                montant_transfere: element.montant_transfere.toLocaleString(),
                montant_commission: element.montant_commission.toLocaleString(),
                montant_tva: element.montant_tva.toLocaleString(),
                montant_ttc: element.montant_ttc.toLocaleString(),
                reliquat: element.reliquat.toLocaleString(),
                tarif: element.tarif.toLocaleString(),
                taux_commission: element.taux_commission,
                taux_tva: element.taux_tva,
                code_envoi: element.code_envoi,
                num_transation: element.num_transation,
                created_at: element.created_at,
                date_operation: element.date_operation,
                updated_at: element.updated_at,
                deleted_at: element.deleted_at
                //btn: "<router-link to='/theme/mandates/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    },
    rows_paiement(state){
        let data = []
        let row = {
            actif: "",
            adresse: "",
            autorise_annulation: null,
            centre_appel: null,
            code_envoi: null,
            created_at: "",
            date_operation: null,
            deleted_at: null,
            entite_id: "",
            entite_nom: "",
            entite_type: "",
            groupage: "",
            guichet_id: null,
            id: "",
            infos_dynamique: null,
            modelpaiement_id: "",
            montant_commission: "",
            montant_transfere: "",
            montant_ttc: "",
            montant_tva: "",
            nom: "",
            num_piece: null,
            num_transaction: "",
            paiement_adresse_payeur: "",
            paiement_code: "",
            paiement_model: "",
            paiement_motif: "",
            paiement_nb_benef: "",
            paiement_payeur: "",
            paiement_telephone_payeur: "",
            paiementfile_id: "",
            piece_libelle: null,
            prenom: null,
            reliquat: "",
            rembourse: "",
            tarif: "",
            taux_commission: "",
            taux_tva: "",
            telephone: "",
            typeoperation_code: "",
            updated_at: "",
            user_id: "",
            user_nom: "",
            valide: "",
            btn:""
        }
        state.paiement.forEach(element => { 
                
            row = {
                actif: element.actif,
                adresse: element.adresse.toUpperCase(),
                autorise_annulation: element.autorise_annulation,
                centre_appel: element.centre_appel,
                code_envoi: element.code_envoi,
                created_at: element.created_at,
                date_operation: element.date_operation,
                deleted_at: element.deleted_at,
                entite_id: element.entite_id,
                entite_nom: element.entite_nom,
                entite_type: element.entite_type,
                groupage: element.groupage,
                guichet_id: element.guichet_id,
                id: element.id,
                infos_dynamique: element.infos_dynamique,
                modelpaiement_id: element.modelpaiement_id,
                montant_commission: element.montant_commission.toLocaleString(),
                montant_transfere: element.montant_transfere.toLocaleString(),
                montant_ttc: element.montant_ttc.toLocaleString(),
                montant_tva: element.montant_tva.toLocaleString(),
                nom: element.nom,
                num_piece: element.num_piece,
                num_transation: element.num_transation,
                paiement_adresse_payeur: element.paiement_adresse_payeur,
                paiement_code: element.paiement_code,
                paiement_model: element.paiement_model,
                paiement_motif: element.paiement_motif,
                paiement_nb_benef: element.paiement_nb_benef,
                paiement_payeur: element.paiement_payeur,
                paiement_telephone_payeur: element.paiement_telephone_payeur,
                paiementfile_id: element.paiementfile_id,
                piece_libelle: element.piece_libelle,
                prenom: element.prenom,
                reliquat: element.reliquat.toLocaleString(),
                rembourse: element.rembourse.toLocaleString(),
                tarif: element.tarif.toLocaleString(),
                taux_commission: element.taux_commission.toLocaleString(),
                taux_tva: element.taux_tva.toLocaleString(),
                telephone: element.telephone,
                typeoperation_code: element.typeoperation_code,
                updated_at: element.updated_at,
                user_id: element.user_id,
                user_nom: element.user_nom,
                valide: element.valide
                //btn: "<router-link to='/theme/mandates/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    },
    rowsModels(state){
        let data = []
        let row = {
            id: "",
            nom: "",
            prenom: "",
            adresse: "",
            telephone: "",
            model: "",
            montant_transfere: "",
            periodicite_jour: "",
            grilletarifaires_libelle:"",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.models.forEach(element => { 
                 
            row = {
                id: element.id,
                nom: element.nom,
                prenom: element.prenom,
                adresse: element.adresse,
                telephone: element.telephone,
                model: element.model,
                montant_transfere: element.montant_transfere.toLocaleString(),
                periodicite_jour: element.periodicite_jour.toLocaleString(),
                grilletarifaires_libelle: element.grilletarifaires_libelle,
                created_at: element.created_at,
                updated_at: element.updated_at,
                deleted_at: element.deleted_at
                //btn: "<router-link to='/theme/mandates/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    },
    getMontant(state){
        return state.montantttc;
    },
    getLinesError(state){
        console.log("mes erreurs ",state.linesError)
        let data = []
        let row ={}
        // let row = {
        //     error: {},
        //     identifiant: "",
        //     montant_transfere: "",
        //     nom: "",
        //     prenom: "",
        //     telephone: ""
        // }
        state.linesError.forEach(element => {
            // for(var key in element){
            //     row = {
            //         key:element
            //     }
            // }
            if(typeof(element.Erreur)!='string'){
                let errors = ''
                let delimiter = ''
                for (let prop in element.Erreur) {
                    errors += delimiter + '' + element.Erreur['' + prop]
                    delimiter = ','

                }
                element.Erreur = errors
            }
            
            // row = {
            //     error: errors,
            //     identifiant: element.identifiant == null ? null : element.identifiant,
            //     montant_transfere: element.montant_transfere == null ? null : element.montant_transfere,
            //     nom: element.nom == null ? null : element.nom,
            //     prenom: element.prenom == null ? null : element.prenom,
            //     telephone: element.telephone == null ? null : element.telephone
            //     }
            console.log(element.Erreur)
            data.push(element)
        });
        return data;
    },
    getRecentRetrait(state){
        let data = []
        let row = {
            link:'',
            name:'',
            date:''
        }
        state.recent_retrait.forEach(element=>{
            row = {
                link:element.link,
                name: element.name,
                date: element.date
            }
        })

    },
    getCodes(state){
        let data = []
        let row = {
            id: "",
            code_paiement: ""
        }
        state.codes.forEach(element => {
            row = {
                id: element.id,
                code_paiement: element.code_paiement
            }
            data.push(row)
        })
        return data;
    }
}
const mutations= {
    setMandate(state, mandates) {
        state.all = mandates
    },
    setCodes(state, codes) {
        state.codes = codes
    },
    setPaiement(state, mandates) {
        state.paiement = mandates
    },
    setModel(state, model) {   
        state.models = model
    },
    setLineError(state, lines) {
        state.linesError = lines
    },
    addMandate(state,mandate){
        state.all.push(mandate)
    },
    setMontantTTC(state,data){
        state.montantttc=data
    },
    setRecentRetrait(state,data){
        var q = new Date();
        var m = q.getMonth();
        var d = q.getDate();
        var y = q.getFullYear();
        var date_r = new Date(y, m, d);
        let dt = {
            link: data.content,
            name: data.filename,
            date: d + "-" + parseInt(m + 1) + "-" + y
        }
        if (state.recent_retrait.length==5){
            let temp = state.recent_retrait
            state.recent_retrait.pop()
            state.recent_retrait.push(dt)
            state.recent_retrait.splice(0, 1, temp[1]) // replaces 1 element at 0th index to temp[] at recent_retrait[]
            state.recent_retrait.splice(1,1,temp[2])
            state.recent_retrait.splice(2,1,temp[3])
            state.recent_retrait.splice(3,1,temp[4])

        } else if (state.recent_retrait.length == 5){
            state.recent_retrait.push(dt)
        }
        
    }
}

const actions={
    get_all_mandates({ commit }, serverParams){
        return api.mandate.get_all_mandates(serverParams).then((response)=>{
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
    },
    get_all_model({ commit }){
        return api.mandate.get_all_model().then((response)=>{
            //console.log("model : ",response.data.data.data)
            commit('setModel', response.data.data.data)
            return response.data.data
        })
    },
    get_model_by_id({ commit },id_model){
        return api.mandate.get_model_by_id(id_model).then((response)=>{
            //console.log("model : ",response.data.data.data)
            //commit('setModel', response.data.data.data)
            return response.data.data
        })
    },
    get_mandate_by_id({ commit }, id_mandat){
        return api.mandate.get_mandate_by_id(id_mandat).then((response)=>{
            //console.log(response.data.data)
            return response.data.data
        })
    },
    get_paiement_by_id({ commit }, id_mandat){
        return api.mandate.get_paiement_by_id(id_mandat).then((response)=>{
            //console.log(response.data.data)
            return response.data.data
        })
    },
    impression_operation({ commit }, id_mandat){
        return api.mandate.impression_operation(id_mandat).then((response)=>{
            //console.log(response.data.data)
            return response.data.data
        })
    },
    impression_statut_paiement({ commit }, id_mandat){
        return api.mandate.impression_statut_paiement(id_mandat).then((response)=>{
            //console.log(response.data.data)
            return response.data
        })
    },
    get_all_mandates_own({ commit }){
        return api.mandate.get_all_mandates_own().then((response)=>{
            console.log('mes opérations :', response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_mandates_by_guichet({ commit }, guichet_id){
        return api.mandate.get_all_mandates_by_guichet(guichet_id).then((response)=>{  
            commit('setMandate', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_mandates_by_user({ commit }, user_id){
        return api.mandate.get_all_mandates_by_user(user_id).then((response)=>{  
            commit('setMandate', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_mandates_by_agency({ commit }, agence_id){
        return api.mandate.get_all_mandates_by_agency(agence_id).then((response)=>{  
            commit('setMandate', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_mandates_setting({commit},mandate){
        return api.mandate.get_all_mandates_setting(mandate).then((response)=>{
            commit('setMandate', response.data.data.data)
            return response.data.data.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    get_all_code_paiement({commit},mandate){
        return api.mandate.get_all_code_paiement(mandate).then((response)=>{
            commit('setCodes', response.data.data.data)
            return response.data.data.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    cancel_paiement({commit},paiement){
        return api.mandate.cancel_paiement(paiement).then((response)=>{
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_paiement({commit},paiement){
        return api.mandate.post_paiement(paiement).then((response)=>{
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_mandates({commit},mandates){
        return api.mandate.post_mandates(mandates).then((response)=>{
            //commit('setMandate', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_model({commit},model){
        return api.mandate.post_model(model).then((response)=>{
            //commit('setMandate', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    put_model({commit},model){
        return api.mandate.put_model(model.id,model).then((response)=>{
            //commit('setMandate', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    put_mandates({commit},data){
        return api.mandate.put_mandates(data.id, { motif: data.motif,nom_benef: data.nom_benef,prenom_benef:data.prenom_benef,_method:'PUT'}).then((response)=>{
            //commit('setMandate', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_mandates_by_date({commit},data){
        return api.mandate.post_mandates_by_date(data).then((response)=>{
            //console.log('nouvelle donnée ',response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_paiement_by_date({commit},data){
        return api.mandate.post_paiement_by_date(data).then((response)=>{
            //console.log(response.data.data.data)
            commit('setPaiement', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_mandates_by_date_me({commit},data){
        return api.mandate.post_mandates_by_date_me(data).then((response)=>{
            //console.log('nouvelle donnée ',response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_mandatesEntite_by_date_me({commit},data){
        return api.mandate.post_mandatesEntite_by_date_me(data).then((response)=>{
            //console.log('nouvelle donnée ',response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_mandates_by_entite_by_date_me({commit},data){
        return api.mandate.post_mandates_by_entite_by_date_me(data).then((response)=>{
            console.log('nouvelle donnée ',response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_mandates_by_agence_by_date_me({commit},data){
        return api.mandate.post_mandates_by_agence_by_date_me(data).then((response)=>{
            console.log('nouvelle donnée ',response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_mandates_by_guichet_by_date_me({commit},data){
        return api.mandate.post_mandates_by_guichet_by_date_me(data).then((response)=>{
            console.log('nouvelle donnée ',response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_mandates_by_user_by_date_me({commit},data){
        return api.mandate.post_mandates_by_user_by_date_me(data).then((response)=>{
            console.log('nouvelle donnée ',response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_mandates_by_typepiece_by_date_me({commit},data){
        return api.mandate.post_mandates_by_typepiece_by_date_me(data).then((response)=>{
            console.log('nouvelle donnée ',response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_mandates_by_typeoperation_by_date_me({commit},data){
        return api.mandate.post_mandates_by_typeoperation_by_date_me(data).then((response)=>{
            console.log('nouvelle donnée ',response.data.data.data)
            commit('setMandate', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            //console.log("eeror : ", error.response.data)
            return error.response.data
        })
    },
    post_tableau_bord_by_date_me_imprim({ commit }, data){
        return api.mandate.post_tableau_bord_by_date_me_imprim(data).then((response)=>{
            return response
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_tableau_bord_distrib_by_date_me_imprim({ commit }, data){
        return api.mandate.post_tableau_bord_distrib_by_date_me_imprim(data).then((response)=>{
            return response
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_decaissement_by_date_me_imprim_entite({ commit }, data){
        return api.mandate.post_decaissement_by_date_me_imprim_entite(data).then((response)=>{
            return response
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_decaissement_by_date_me_imprim_agence({ commit }, data){
        return api.mandate.post_decaissement_by_date_me_imprim_agence(data).then((response)=>{
            return response
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_decaissement_by_date_me_imprim_guichet({ commit }, data){
        return api.mandate.post_decaissement_by_date_me_imprim_guichet(data).then((response)=>{
            return response
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_mandates_by_date_me_imprim({ commit }, data){
        return api.mandate.post_mandates_by_date_me_imprim(data).then((response)=>{
            return response
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_mandates_by_entite_imprim({ commit }, data){
        return api.mandate.post_mandates_by_entite_imprim(data).then((response)=>{
            return response
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_mandates_by_agence_imprim({ commit }, data){
        return api.mandate.post_mandates_by_agence_imprim(data).then((response)=>{
            return response
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_mandates_by_guichet_imprim({ commit }, data){
        return api.mandate.post_mandates_by_guichet_imprim(data).then((response)=>{
            return response
        })
        .catch(error=>{
            return error.response.data
        })
    },
    info_paiement({ commit }, paiement_file){
        return api.mandate.info_paiement(paiement_file).then((response)=>{
            return response.data
        })
        .catch(error=>{
            if (error.response.data.data){
                commit('setLineError', error.response.data.data)
            }
            return error.response.data
        })
    },
    montantttc({commit},data){
        return api.mandate.montantttc(data).then((response)=>{
            commit('setMontantTTC',response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    getInfobyNumTrans({ commit }, num_transation){
        return api.mandate.getInfobyNumTrans(num_transation).then((response)=>{   
            return response.data            
        }).catch(error => {
            return error.response.data
        })
    },
    getInfobyNumTransPlafond({ commit }, num_transation){
        return api.mandate.getInfobyNumTransPlafond(num_transation).then((response)=>{   
            return response.data            
        }).catch(error => {
            return error.response.data
        })
    },
    getInfoPaiement({ commit }, data){
        //console.log(data)
        return api.mandate.getInfoPaiement(data).then((response)=>{   
            return response.data            
        }).catch(error => {
            return error.response.data
        })
    },
    AnnulerPaiement({ commit }, data){
        //console.log(data)
        return api.mandate.AnnulerPaiement(data).then((response)=>{   
            return response.data            
        }).catch(error => {
            return error.response.data
        })
    },
    getInfobyNumTransAnnulation({ commit }, num_transation){
        return api.mandate.getInfobyNumTransAnnulation(num_transation).then((response)=>{   
            return response.data            
        }).catch(error => {
            return error.response.data
        })
    },
    validateRetrait({ commit }, code_envoie){
        return api.mandate.validateRetrait(code_envoie).then((response)=>{      
            //console.log(response.data)
            return response.data            
        })
        .catch(error => {
            return error.response.data
        })
    },
    validateInfoPaiement({ commit }, data){
        return api.mandate.validateInfoPaiement(data).then((response)=>{      
            //console.log(response.data)
            return response.data            
        })
        .catch(error => {
            return error.response.data
        })
    },
    validateAnnulation({ commit }, code_envoie){
        return api.mandate.validateAnnulation(code_envoie).then((response)=>{      
            //console.log(response.data)
            return response.data            
        })
        .catch(error => {
            return error.response.data
        })
    },
    AutoriseAnnulation({ commit }, code_envoie){
        return api.mandate.AutoriseAnnulation(code_envoie).then((response)=>{      
            //console.log(response.data)
            return response.data            
        })
        .catch(error => {
            return error.response.data
        })
    },
    put_deblocage({ commit }, data){
        return api.mandate.put_deblocage(data).then((response)=>{      
            //console.log(response.data)
            return response.data            
        })
        .catch(error => {
            return error.response.data
        })
    },
    deblocage({ commit }, data){
        return api.mandate.deblocage(data).then((response)=>{      
            //console.log(response.data)
            return response.data            
        })
        .catch(error => {
            return error.response.data
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
